import { useEffect, useRef, useState } from 'react';
import { formatDedicatedReadingTime } from '../../domain/readingLevel';
import { LEVEL_UP_EVENT, type LevelUpEventDetail } from '../../services/levelUpService';

export const LevelUpNotice = () => {
  const [levelUp, setLevelUp] = useState<LevelUpEventDetail>();
  const timerRef = useRef<number | undefined>(undefined);

  useEffect(() => {
    const show = (event: Event) => {
      const detail = (event as CustomEvent<LevelUpEventDetail>).detail;
      if (!detail || !Number.isInteger(detail.currentLevel) || detail.currentLevel < 1) return;
      if (timerRef.current !== undefined) window.clearTimeout(timerRef.current);
      setLevelUp(detail);
      timerRef.current = window.setTimeout(() => setLevelUp(undefined), 2600);
    };
    window.addEventListener(LEVEL_UP_EVENT, show);
    return () => {
      window.removeEventListener(LEVEL_UP_EVENT, show);
      if (timerRef.current !== undefined) window.clearTimeout(timerRef.current);
    };
  }, []);

  if (!levelUp) return null;
  return (
    <div className="level-up-notice" role="status" aria-live="polite">
      <div className="level-up-notice__rule" aria-hidden="true" />
      <span>Um novo capítulo</span>
      <strong>Level {levelUp.currentLevel}</strong>
      <p>Você alcançou o Level {levelUp.currentLevel}</p>
      <small>{formatDedicatedReadingTime(levelUp.totalMinutes)}</small>
    </div>
  );
};
